import { useGuideDriver } from './use-guide-driver';
import { useRecommend } from './use-recommend';
import { useCouponTaskDialog } from './use-coupon-task-dialog';
import { useChannelCouponDialog, ChannelKey, useShowByNewUserState } from '../components/channel-coupon-dialog/use-channel-coupon-dialog';
import { watch } from '@vue/composition-api';

export const useDialogManager = () => {
  const { showConfig: guideDriverConfig } = useGuideDriver();
  const { showData: recommendShowData, showDialog: showRecommendDialog } = useRecommend();
  const { showDialogByUrl: showCouponTaskDialog } = useCouponTaskDialog();
  const { showDialog: showChannelCouponDialog, isNeedShowDialog: isNeedShowChannelCouponDialog } = useChannelCouponDialog();
  const isShowByNewUser = useShowByNewUserState();

  /**
   * 判断并打开从渠道过来的弹窗
   */
  const checkAndOpenChannelCouponDialog = () => {
    if (isNeedShowChannelCouponDialog(ChannelKey.ScanForPerks)) {
      showChannelCouponDialog(ChannelKey.ScanForPerks);
      return true;
    }
  };

  /**
   * 特殊逻辑，当用户关闭新用户弹窗之后，需要立即打开渠道弹窗
   */
  watch(isShowByNewUser, () => {
    if (isShowByNewUser.value) {
      checkAndOpenChannelCouponDialog();
    }
  });

  /** 处理多个弹窗关联逻辑 */
  const handleAllDialog = async () => {
    // 如果要展示新手指引，则不处理其他弹窗
    if (guideDriverConfig.isNeedShow) {
      return;
    }

    // 判断渠道弹窗是否打开，并打开
    if (checkAndOpenChannelCouponDialog()) {
      return;
    };

    // 判断isNeedShow,展示推荐弹窗
    if (recommendShowData.isNeedShow) {
      await showRecommendDialog();
      return;
    }

    // 旧弹窗逻辑
    // 5月，有新手任務的用戶：只彈新手彈窗
    // 5月，其他用戶：改版彈窗 -> 任務彈窗(每月一次)
    // 6月，有新手任務的用戶
    // 6月，任務彈窗
  };
  /** 处理券 or 任务全局详情弹窗 */
  const handleCouponTaskDialog = async () => {
    await showCouponTaskDialog();
  };

  return { handleAllDialog, handleCouponTaskDialog };
};
